import React from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import LedgerTable from './LedgerTable';

function DayBook() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="LedgerReport" 
        breadcrumb={["Dashboard", "Accounts", "Ledger Report"]} 
      />

      <HStack align="start" w="full"  gap="0" mt={4} p={6}>
        <LedgerTable colors={colors} />

      </HStack>
    </div>
  );
}

export default DayBook;
